"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETrafficEvents = void 0;
var ETrafficEvents;
(function (ETrafficEvents) {
    ETrafficEvents["requests"] = "requests";
    ETrafficEvents["requestsWithLogVolume"] = "requestsWithLogVolume";
    ETrafficEvents["bidFloor"] = "bidFloor";
})(ETrafficEvents || (exports.ETrafficEvents = ETrafficEvents = {}));
